import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { usePopup } from '../common/Popup';


const Container = styled.div`
  width: 100%;
  max-width: 720px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 40px 70px 40px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 35px auto 0 auto;
`;

const TextContainer = styled.div`
  max-height: 450px;
  font-size: 16px;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.5;
  text-align: left;

  h4 {
    font-weight: bold;
  }

  p {
    margin-bottom: 10px;
  }

  b {
    font-weight: bold;
  }

  i {
    font-style: italic;
  }
`;

const DownloadButton = styled.button`
  background-color: transparent;
  color: #f08c00;
  font-size: 16px;
  font-weight: 500;
  border: 2px solid #f08c00;
  border-radius: 8px;
  padding: 8px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background-color: #ffe5b3;
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: #6ab292;
  color: white;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  padding: 8px 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #5a9e82;
  }
`;

const TermFile = () => {
  const navigate = useNavigate();
  const popup = usePopup();
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleNext = () => {
    navigate('/PreenchaDados');
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await fetch(`${baseUrl}/orientacoes-tct`);
      
      if (!response.ok) {
        throw new Error('Erro ao baixar o arquivo');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'orientacoes-tct.docx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
      await popup.alert({
        icon: 'warning',
        title: 'Erro ao baixar o arquivo',
        message: 'Tente novamente.',
      });
    } finally {
      setIsDownloading(false);
    }
  };    

  return (
    <Container>
      <TextContainer>
        <p>
          Para realizar o cadastro da instituição será necessário o envio do <b>Termo de Cooperação Técnica</b>.
          O arquivo abaixo contém as orientações para à celebração de cooperação técnica para a realização
          de estágios obrigatórios nas Unidades da Secretaria de Estado da Saúde de Santa Catarina (SES/SC).
          Siga as orientações e então realize o cadastro no sistema <i>TECNEPS</i>.
        </p>
      </TextContainer>

      <DownloadButton onClick={handleDownload} disabled={isDownloading}>
        <span className="material-symbols-outlined">
          {isDownloading ? 'hourglass_empty' : 'download'}
        </span> 
        {isDownloading ? 'Baixando...' : 'Baixar orientações'}
      </DownloadButton>

      <TextContainer>
        <p>Já possui o <b>Termo de Cooperação Técnica</b>? Então prossiga com o cadastro no sistema.</p>
      </TextContainer>

      <ButtonContainer>
        <Button onClick={handleNext}>Tenho o termo</Button>
      </ButtonContainer>
    </Container>
  );
};

export default TermFile;
